import request from "@/utils/request";

export default {
    queryReport(param) {
        return request({
            url: "/sensory-report/query",
            method: "POST",
            data: param
        })
    },
    deleteReportForDraft(ttSensoryReportId) {
        return request({
            url: `/sensory-report/deleteReportForDraft/${ttSensoryReportId}`,
            method: "get",
        })
    },
    getDetail(id) {
        return request({
            url: "/sensory-report/queryDetailByReportId",
            method: "POST",
            data: id
        })
    },
    save(data) {
        return request({
            url: "/sensory-report/draft",
            method: "POST",
            data: data
        })
    },
    submit(data) {
        return request({
            url: "/sensory-report/submit",
            method: "post",
            data: data
        })
    },
    inactive(id, reason) {
        return request({
            url: `/sensory-report/inactive/${id}`,
            method: "post",
            data: reason
        })
    },
    exportList(param) {
        return request({
            url: `/sensory-report/export`,
            method: "post",
            data: param,
            responseType: 'blob',
            fullResponse: true,
        })
    },
    exportDetail(id) {
        return request({
            url: `/sensory-report/exportDetail/${id}`,
            method: "get",
            responseType: 'blob',
            fullResponse: true,
        })
    },
    exportPrintExcel(param) {
        return request({
            url: `/sensory-report/exportPrintExcel`,
            method: "post",
            data: param,
            responseType: 'blob',
            fullResponse: true,
        })
    },
    qualified(id) {
        return request({
            url: `/sensory-supplier-rater/qualified?tmUserId${id}`,
            method: "get",
        })
    },
}